__turbopack_context__.v({
  "comparisonTable": "ComparisonTable-module-scss-module__OySRcq__comparisonTable",
  "head": "ComparisonTable-module-scss-module__OySRcq__head",
  "row": "ComparisonTable-module-scss-module__OySRcq__row",
  "title": "ComparisonTable-module-scss-module__OySRcq__title",
  "titleColumn": "ComparisonTable-module-scss-module__OySRcq__titleColumn",
});
